<template>
  <div class="language-switch">
    <el-tooltip
      content="Switch to English language"
      placement="top"
      effect="light"
    >
      <img
        src="/img/united-kingdom.png"
        alt="United Kingdom"
        @click="clickGbr"
      />
    </el-tooltip>

    <el-tooltip
      content="Переключиться на русский язык"
      placement="top"
      effect="light"
    >
      <img
        class="menu-small-item-before"
        src="/img/russia.png"
        alt="Русский"
        @click="clickRus"
      />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitch",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    clickGbr() {
      this.$emit("switchGbr");
    },
    clickRus() {
      this.$emit("switchRus");
    }
  }
};
</script>

<style lang="scss" scoped>
.language-switch {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  img {
    width: 25px;
    margin-left: 5px;
  }
}
</style>
